import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  API_URL = 'https://webapp.sitetraxx.com/api/';
//  API_URL = 'https://test-webapp.sitetraxx.com/api/';
//  API_URL = 'http://localhost:22612/api/';
  constructor() { }
}
